import { Controller } from '@hotwired/stimulus'
import Pickr from '@simonwep/pickr'
import '@simonwep/pickr/dist/themes/monolith.min.css'
import { debounce } from 'throttle-debounce'

export default class ColorPickerController extends Controller<HTMLInputElement> {
  declare pickr: Pickr
  declare debouncedUpdate: ReturnType<typeof debounce>

  connect() {
    if (!this.element.readOnly) {
      this.debouncedUpdate = debounce(150, this.#updateInput.bind(this))
      this.pickr = Pickr.create(this.#getOptions())
        .on('init', (pickr: Pickr) => {
          this.#updateInput(pickr.getSelectedColor())
        })
        .on('change', this.debouncedUpdate)
    }
  }

  disconnect() {
    if (!this.element.readOnly) {
      this.pickr.destroy()
      this.debouncedUpdate.cancel()
    }
  }

  // Private methods

  /** @link https://github.com/Simonwep/pickr#options */
  #getOptions() {
    return {
      closeOnScroll: true,
      components: {
        hue: true,
        interaction: { input: true },
        preview: true,
      },
      default: this.element.value || '#888888',
      el: this.element,
      position: 'top-end',
      theme: 'monolith',
      useAsButton: true,
    } satisfies Pickr.Options
  }

  #updateInput(color: Pickr.HSVaColor) {
    if (color === null) return

    this.element.value = color.toHEXA().toString()
    this.element.dispatchEvent(new Event('input'))
  }
}
